import React, { useState, useEffect } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import styles from "./ForgotRestore.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import config from "../../../settings/config";
import { useToast } from "../../../context/ToastContext";

const ForgotRestore = () => {
    const navigate = useNavigate();
    const [code, setCode] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [successButton, setSuccessButton] = useState(false);
    const [loading, setLoading] = useState(false);
    const { setToast } = useToast();

    const showToast = (message, type, time) => {
        setToast({ message, type });
        setTimeout(() => setToast(null), time);
    };

    useEffect(() => {
        if (code.length > 0 && password.length > 0 && confirmPassword.length > 0 &&
            password === confirmPassword
        ) {
            setSuccessButton(true);
        } else {
            setSuccessButton(false);
        }
    }, [code, password, confirmPassword]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!(code.length > 0 && password.length > 0 && confirmPassword.length > 0)) {
            showToast("Заполните все поля", "warn", 3000 );
            return;
        }

        if (password !== confirmPassword) {
            showToast("Пароли не совпадают", "warn", 3000 );
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(`${config.app.host}/api/v1/reset-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    code: code,
                    password: password,
                    confirmPassword: confirmPassword,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "При смене пароля произошла ошибка, попробуйте снова!");
            }
            showToast("Пароль успешно изменен!", "success", 5000);
            navigate('/');
        } catch (err) {
            showToast(err.message, "error", 3000);
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        navigate(-1);
    }

    return (
        <div className={styles.container}>
            <h3>Восстановление пароля</h3>
            <div className={styles.form}>
                Код
                <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Введите код"
                    required
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                />
                Пароль
                <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Введите новый пароль"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                Повторите пароль
                <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Повторите пароль"
                    required
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />

                <div className={styles.delimeterStyle}></div>

                <button
                    className={successButton ? styles.buttonContinueOn : styles.buttonContinue}
                    onClick={handleSubmit}
                >
                    {loading ? "Подождите..." : "Сменить пароль"}
                </button>
                <button
                    className={styles.backButton}
                    onClick={handleBack}
                >
                    Назад
                </button>
            </div>
        </div>
    );
};

export default ForgotRestore;
